import React from 'react';
import './DateSpan.scss';
import { FormattedDate } from 'react-intl';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  firstDate: Date;
  lastDate?: Date;
  dateFormat: 'short' | 'medium' | 'long';
  style?: string;
}

const DateSpan: React.SFC<IProps> = ({
  firstDate,
  lastDate,
  dateFormat,
  style,
}) => {

  if (!firstDate && !lastDate) {
    return null;
  }

  const dateStyle = `datespan ${ style ? style : '' }`;

	const isOneDate = (
    (firstDate && !lastDate || !firstDate && lastDate) ||
    firstDate.getDate() === lastDate.getDate() &&
    firstDate.getMonth() === lastDate.getMonth() &&
    firstDate.getFullYear() === lastDate.getFullYear()
  );
	
	if (isOneDate && dateFormat === 'short') {
		return (
      <span className={ dateStyle }>
        <span className='bold capitalize'>
          <FormattedDate 
            value={ firstDate }
            month='short'
            day='numeric'
          />&nbsp;
        </span>
        <FormattedDate 
          value={ firstDate }
          year='numeric'
        />
      </span>
		);
  }

  if (isOneDate && dateFormat === 'medium') {
    return (
      <span className={ dateStyle }>
        <span className='bold capitalize'>
          <FormattedDate 
            value={ firstDate }
            month='short'
            day='numeric'
            weekday='long'
          />&nbsp;
        </span>
        <FormattedDate 
          value={ firstDate }
          year='numeric'
        />
      </span>
		);
  }

  if (isOneDate && dateFormat === 'long') {
    return (
      <div className={ dateStyle }>
        <span className='bold capitalize'>
          <FormattedDate 
            value={ firstDate }
            month='long'
            day='numeric'
            weekday='long'
          />&nbsp;
        </span>
        <FormattedDate 
          value={ firstDate }
          year='numeric'
        />
      </div>
    );
  }
  
  if (!isOneDate && dateFormat === 'short') {
    return (
      <span className={ dateStyle }>
        <span className='bold capitalize'>
          <FormattedDate 
            value={ firstDate }
            month='short'
            day='numeric'
          />&nbsp;-&nbsp;
          <FormattedDate 
            value={ lastDate }
            month='short'
            day='numeric'
          />&nbsp;
        </span>
        <FormattedDate 
          value={ lastDate }
          year='numeric'
        />
      </span>
    );
  }

  if (!isOneDate && dateFormat === 'long') {
    return (
      <div className={ dateStyle }>
        <span>
          <span className='bold capitalize'>
            <FormattedDate 
              value={ firstDate }
              month='long'
              day='numeric'
              weekday='long'
            />&nbsp;
          </span>
          <FormattedText
            displayName='till'
            formattedName='global.to'
          />
        </span><br />
        <span className='capitalize'>
          <FormattedDate 
            value={ lastDate }
            year='numeric'
            month='long'
            day='numeric'
            weekday='long'
          />
        </span>
      </div>
    );
  }

  return null;
};

export default DateSpan;


// WEBPACK FOOTER //
// ./src/components/Shared/DateSpan/DateSpan.tsx